import { isEditingRouteUtil } from 'modules/routes/utils'
import { createSelector } from 'reselect'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import getPathnameRouterSelect from 'modules/router/selectors/get-pathname'

function isEditingRoutesSelector () {
  return createSelector(
    getInstanceSectionSelector(),
    getCurrentUserSelector(),
    getPathnameRouterSelect,
    (instance, currentUser, pathname) => {
      return (
        isEditingRouteUtil(
          pathname,
          currentUser,
          instance
        )
      )
    }
  )
}

export {
  isEditingRoutesSelector
}
